import React,{useState} from 'react'
import {NavLink} from 'react-router-dom'
import './navbar.css'
import myMenu from "./../../assets/icons/menu.png"
import close from "./../../assets/icons/close.png"
import ModeButton from "../theme/modeButton";

function Navbar() {
   
    const[menu,setMenu]=useState(false)  //set show menu or hide
  return (
    <nav id="navbar">
        <ul style={menu===false ? {right: '-300px'}:{right:0}}>
            <li className="active" onClick={() =>setMenu(false)}><NavLink to="./">home</NavLink></li>
            <li className="active" onClick={() =>setMenu(false)}><NavLink to="/about">about</NavLink></li>
            <li className="active" onClick={() =>setMenu(false)}><NavLink to="/project">projects</NavLink></li>
            <li className="active" onClick={() =>setMenu(false)}><NavLink to="/contect">contect</NavLink></li>
        </ul>       

        
        <button id="mobile" onClick={() =>setMenu(!menu)} >
           {menu===false? <img src={myMenu} alt="" id="img"/>:<img src={close} alt="" id="img"/>}
        </button>
        <ModeButton/>


    </nav>
  )
}

export default Navbar